interface Props {
	page: number;
	total: number;
	pageSize: number;
	onChange: (page: number) => void;
}

/**
 * Пагинация «назад / страница N из M / вперёд».
 *
 * Без номеров страниц намеренно: магазинов и сделок бывает много, а
 * оператор ходит по ним либо поиском, либо подряд — выбирать 47-ю страницу
 * из списка ему незачем.
 */
export const ShopsPagination = ({ page, total, pageSize, onChange }: Props) => {
	const pages = Math.max(1, Math.ceil(total / pageSize));
	if (pages <= 1) return null;

	return (
		<div className='d-flex align-items-center justify-content-end gap-3 pt-4'>
			<button
				type='button'
				className='btn btn-sm btn-light'
				disabled={page <= 1}
				onClick={() => onChange(page - 1)}
			>
				Назад
			</button>
			<span className='text-muted fs-7'>
				Страница {page} из {pages}
			</span>
			<button
				type='button'
				className='btn btn-sm btn-light'
				disabled={page >= pages}
				onClick={() => onChange(page + 1)}
			>
				Вперёд
			</button>
		</div>
	);
};
